export const BASE_URL = window.location.origin;
export const SOCKET_BASE_URL = `${process.env.NODE_ENV === 'development' ? 'ws' : 'wss'}://${
    window.location.host
}`;
export const I18N_CONFIG_KEY = (process.env.REACT_APP_I18N_CONFIG_KEY as string) || 'i18nConfig';
export const NODE_ENV = process.env.NODE_ENV as string;
export const COINFLARE_REGISTER_URL = `${BASE_URL}/register`;
export const DEFAULT_LANGUAGE = 'en-us';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_FUTURE_SYMBOL = 'BTC-SWAP-USDT';
export const DEFAULT_SPOT_SYMBOL = 'BTCUSDT';
export const SITE_MAINTENANCE_URL =
    'https://help.coinflare.com/hc/en-us/articles/36570619800857-Site-Maintenance';
